import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {AddPlayer} from '../models/add-player';
import {Player} from '../../shared/models/player';

export const siteAssignPlayerActionTypes = {
  ADD: type('[Device site] Add'),
  ADD_SUCCESS: type('[Device site] Add Success'),
  ADD_FAIL: type('[Device site] Add Fail')
};

export class SiteAssignPlayerAction implements Action {
  readonly type = siteAssignPlayerActionTypes.ADD;
  constructor(public payload?: AddPlayer) {}
}

export class SiteAssignPlayerSuccessAction implements Action {
  readonly type = siteAssignPlayerActionTypes.ADD_SUCCESS;
  constructor(public payload?: Player) {}
}

export class SiteAssignPlayerFailAction implements Action {
  readonly type = siteAssignPlayerActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
